import React from 'react';
import Theme from '../views/ui/Theme';

const EditIcon = (props) => (
  <svg
    onClick={() => {
      props.close();
      props.click();
    }}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      borderRadius: '50%',
      backgroundColor: Theme.palette.secondary.main,
      padding: '8px',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
      },
      cursor: 'pointer',
    }}
  >
    <path
      d="M13.2594 4.60315L5.04936 13.2931C4.73936 13.6231 4.43936 14.2731 4.37936 14.7231L4.00936 17.9631C3.87936 19.1331 4.71936 19.9331 5.87936 19.7331L9.09936 19.1831C9.54936 19.1031 10.1794 18.7731 10.4894 18.4331L18.6994 9.74315C20.1194 8.24315 20.7594 6.53315 18.5494 4.44315C16.3494 2.37315 14.6794 3.10315 13.2594 4.60315Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8906 6.04688C12.3206 8.80687 14.5606 10.9169 17.3406 11.1969"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EditIcon;
